export const Note = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_319_733)">
      <mask
        id="mask0_319_733"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="18"
        width="15"
        height="4"
      >
        <path
          d="M4.02856 18.5236H18.4036V20.4403C18.4036 20.9696 17.9745 21.3986 17.4452 21.3986H5.94523C4.88668 21.3986 4.02856 20.5405 4.02856 19.482V18.5236Z"
          fill="black"
        />
      </mask>
      <g mask="url(#mask0_319_733)">
        <path
          d="M19.8411 20.4403C19.8411 21.7635 18.7684 22.8361 17.4452 22.8361H5.94523C4.09277 22.8361 2.59106 21.3344 2.59106 19.482H5.46606C5.46606 19.7466 5.6806 19.9611 5.94523 19.9611H16.9661L19.8411 20.4403ZM5.94523 22.8361C4.09277 22.8361 2.59106 21.3344 2.59106 19.482V18.5236H5.46606V19.482C5.46606 19.7466 5.6806 19.9611 5.94523 19.9611V22.8361ZM19.8411 18.5236V20.4403C19.8411 21.7635 18.7684 22.8361 17.4452 22.8361L16.9661 19.9611V18.5236H19.8411Z"
          fill="currentColor"
        />
      </g>
      <path
        d="M12 8.16666L12 9.16666"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 13.1667V14.1667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 13.1667H12.75C13.0815 13.1667 13.3995 13.0613 13.6339 12.8738C13.8683 12.6862 14 12.4319 14 12.1667C14 11.9014 13.8683 11.6471 13.6339 11.4595C13.3995 11.272 13.0815 11.1667 12.75 11.1667H11.25C10.9185 11.1667 10.6005 11.0613 10.3661 10.8738C10.1317 10.6862 10 10.4319 10 10.1667C10 9.90144 10.1317 9.64709 10.3661 9.45955C10.6005 9.27201 10.9185 9.16666 11.25 9.16666H13.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 5.16666H6H17C17.5523 5.16666 18 5.61437 18 6.16666V17.1667M6 7.66666V18.1667C6 19.2712 6.89543 20.1667 8 20.1667H13"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M3 8.16666V6.66666C3 5.83823 3.67157 5.16666 4.5 5.16666V5.16666C5.32843 5.16666 6 5.83823 6 6.66666V8.16666"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M8 20.1667H8.76224C9.31452 20.1667 9.76224 19.7189 9.76224 19.1667V17.1667L21 17.1667V18.1667C21 19.2712 20.1046 20.1667 19 20.1667H8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_319_733">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.166656)"
        />
      </clipPath>
    </defs>
  </svg>
);
